/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

(function () {
  function parseVariantMap(picker) {
    var script = picker.querySelector('script[data-variant-map]');
    if (!script) return null;
    try {
      return JSON.parse(script.textContent);
    } catch (error) {
      return null;
    }
  }

  function selectedOptionInputs(form) {
    return Array.from(form.elements)
      .filter(function (el) {
        return el.matches('input[data-option-position]:checked, input[data-option-position][type="hidden"], select[data-option-position]');
      })
      .sort(function (a, b) {
        return Number(a.getAttribute('data-option-position')) - Number(b.getAttribute('data-option-position'));
      });
  }

  function applyOptionValues(form, optionValues) {
    optionValues.forEach(function (id, index) {
      var position = String(index + 1);
      var radio = form.querySelector('input[data-option-position="' + position + '"][value="' + id + '"]');
      if (radio && !radio.checked) {
        radio.checked = true;
      }
      var select = form.querySelector('select[data-option-position="' + position + '"]');
      if (select && String(select.value) !== String(id)) {
        select.value = String(id);
      }
    });
  }

  function optionValueIsAvailable(map, optionIndex, optionValueId, selectedIds) {
    return map.some(function (variant) {
      if (variant.available === false) return false;
      var values = variant.option_values.map(String);
      if (String(values[optionIndex]) !== String(optionValueId)) return false;
      for (var i = 0; i < optionIndex; i++) {
        if (String(values[i]) !== String(selectedIds[i])) return false;
      }
      return true;
    });
  }

  function hideUnavailableOptions(picker) {
    var map = parseVariantMap(picker);
    if (!map || !map.length) return;
    var form = document.forms[picker.getAttribute('form-id')];
    if (!form) return;
    var selectedIds = selectedOptionInputs(form).map(function (el) { return String(el.value); });

    Array.from(form.querySelectorAll('[data-option-position]')).forEach(function (el) {
      if (el.type === 'hidden') return;
      var position = Number(el.getAttribute('data-option-position'));
      if (!position) return;
      var available = optionValueIsAvailable(map, position - 1, el.value, selectedIds);
      if (el.tagName === 'OPTION') {
        el.hidden = !available;
        el.disabled = !available;
        return;
      }
      var wrap = el.closest('.color-swatch, .variant-swatch, .block-swatch');
      if (wrap) {
        wrap.hidden = !available;
        wrap.classList.toggle('is-unavailable', !available);
      }
    });
  }

  function refreshUnavailableOptions() {
    document.querySelectorAll('variant-picker').forEach(hideUnavailableOptions);
  }

  document.addEventListener('change', function (event) {
    var input = event.target;
    if (!input || !input.matches || !input.matches('[data-option-position]')) return;
    if (!input.name || input.name.indexOf('option') === -1) return;

    var picker = input.closest('variant-picker');
    if (!picker) return;

    var map = parseVariantMap(picker);
    if (!map || !map.length) return;

    var form = document.forms[picker.getAttribute('form-id')];
    if (!form) return;

    var selectedIds = selectedOptionInputs(form).map(function (el) { return String(el.value); });
    var changedId = String(input.value);
    var changedPos = Number(input.getAttribute('data-option-position'));

    var exact = map.find(function (variant) {
      return variant.available !== false && variant.option_values.map(String).join(',') === selectedIds.join(',');
    });
    if (exact) {
      hideUnavailableOptions(picker);
      return;
    }

    var matching = map.filter(function (variant) {
      return variant.option_values.map(String).includes(changedId);
    });
    var available = matching.filter(function (variant) { return variant.available !== false; });
    var pool = available.length ? available : matching;
    if (!pool.length) return;

    var candidates = pool;
    selectedIds.forEach(function (id, index) {
      if (index + 1 === changedPos) return;
      var kept = candidates.filter(function (variant) {
        return String(variant.option_values[index]) === String(id);
      });
      if (kept.length) candidates = kept;
    });

    var best = candidates[0];
    if (!best || !best.option_values || !best.option_values.length) return;
    applyOptionValues(form, best.option_values.map(String));
    hideUnavailableOptions(picker);
  }, true);

  document.addEventListener('variant:changed', function () {
    requestAnimationFrame(refreshUnavailableOptions);
  });
  document.addEventListener('product:rerender', function () {
    requestAnimationFrame(refreshUnavailableOptions);
  }, true);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refreshUnavailableOptions);
  } else {
    refreshUnavailableOptions();
  }
})();

(function () {
  var overlay = null;
  var observed = null;
  var armTimer = null;

  function countryButton() {
    return document.querySelector('#custom__md-footer-selector-block #md-form__select__country--footer')
      || document.querySelector('#md-form__select__country--footer');
  }

  function flagEl(btn) {
    return btn && (btn.querySelector('.md-form__select__country__list__flag-wrapper') || btn);
  }

  function searchInput(btn) {
    return btn && btn.querySelector('.md-form__select__search__input');
  }

  function isOpen(btn) {
    return !!(btn && btn.getAttribute('aria-expanded') === 'true');
  }

  function positionOverlay() {
    var btn = countryButton();
    if (!overlay || !btn || overlay.hidden) return;
    var rect = btn.getBoundingClientRect();
    var pad = 4;
    overlay.style.left = Math.max(0, rect.left - pad) + 'px';
    overlay.style.top = Math.max(0, rect.top - pad) + 'px';
    overlay.style.width = Math.max(44, rect.width + pad * 2) + 'px';
    overlay.style.height = Math.max(44, rect.height + pad * 2) + 'px';
  }

  function ensureOverlay() {
    if (overlay) return overlay;
    overlay = document.createElement('button');
    overlay.type = 'button';
    overlay.id = 'orbe-flag-close';
    overlay.setAttribute('aria-label', 'Close country list');
    overlay.style.cssText = 'position:fixed;z-index:2147483646;margin:0;padding:0;border:0;background:transparent;cursor:pointer;touch-action:manipulation;-webkit-tap-highlight-color:transparent;pointer-events:none;';
    overlay.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();
      var btn = countryButton();
      if (isOpen(btn)) btn.click();
    });
    document.body.appendChild(overlay);
    return overlay;
  }

  function bindSearch(input) {
    if (!input || input.dataset.orbeSearchBound) return;
    input.dataset.orbeSearchBound = '1';
    ['pointerdown', 'pointerup', 'mousedown', 'mouseup', 'touchstart', 'touchend', 'click'].forEach(function (type) {
      input.addEventListener(type, function (event) {
        event.stopPropagation();
      });
    });
  }

  function sync() {
    var btn = countryButton();
    clearTimeout(armTimer);
    bindSearch(searchInput(btn));
    if (isOpen(btn)) {
      var el = ensureOverlay();
      el.hidden = false;
      el.style.pointerEvents = 'none';
      positionOverlay();
      armTimer = setTimeout(function () {
        if (isOpen(countryButton()) && overlay && !overlay.hidden) {
          overlay.style.pointerEvents = 'auto';
        }
      }, window.matchMedia('(min-width: 641px)').matches ? 0 : 500);
    } else if (overlay) {
      overlay.hidden = true;
      overlay.style.pointerEvents = 'none';
    }
  }

  function watchButton() {
    var btn = countryButton();
    if (!btn || btn === observed) return;
    observed = btn;
    var mo = new MutationObserver(sync);
    mo.observe(btn, { attributes: true, attributeFilter: ['aria-expanded'] });
    sync();
  }

  window.addEventListener('resize', positionOverlay, { passive: true });
  window.addEventListener('scroll', positionOverlay, { passive: true, capture: true });
  if (window.visualViewport) {
    window.visualViewport.addEventListener('resize', positionOverlay);
    window.visualViewport.addEventListener('scroll', positionOverlay);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watchButton);
  } else {
    watchButton();
  }
  var mount = document.querySelector('.header__action-item--orbe') || document.querySelector('header') || document.body;
  new MutationObserver(watchButton).observe(mount, { childList: true, subtree: true });
})();


/**
 * Mini-cart: keep the drawer inside the viewport, and keep the chat bubble off the total.
 *
 * theme.js sizes the drawer once, when it opens:
 *
 *   if (item.classList.contains("shopify-section--announcement-bar") && window.scrollY > item.clientHeight) { }
 *   else { headerGroupHeight += item.clientHeight; }
 *   let maxHeight = window.innerHeight - headerGroupHeight;
 *
 * If the page is scrolled past the announcement bar at that moment, the bar is left out of
 * headerGroupHeight. Opening the cart returns the page to the top, the bar comes back, and the
 * drawer is now taller than the space above it by exactly the bar's height. Measured on a
 * 390x844 viewport: drawer top 134, height 768, bottom 902, so the checkout buttons sat 33px
 * below the fold. The height is never recomputed after that first pass.
 *
 * Rather than guess at the offset, measure where the drawer actually starts and work down from
 * there, and redo it whenever the viewport or scroll position moves. visualViewport is preferred
 * over innerHeight because mobile Safari's innerHeight ignores its own bottom URL bar.
 *
 * The theme's own content/recap relationship is kept as-is (content = available - recap height);
 * only the value of `available` is corrected.
 */
(function () {
  var mobile = window.matchMedia('(max-width: 640px)');

  function drawer() {
    return document.querySelector('.mini-cart');
  }

  function isOpen(el) {
    return !!(el && el.getAttribute('aria-hidden') === 'false');
  }

  function viewportHeight() {
    return (window.visualViewport && window.visualViewport.height) || window.innerHeight;
  }

  function clear(el) {
    if (!el) return;
    el.style.removeProperty('max-height');
    el.style.removeProperty('height');
  }

  function fit() {
    var el = drawer();
    if (!el) return;

    var content = el.querySelector('.mini-cart__content');

    // Desktop and the closed state stay the theme's business.
    if (!mobile.matches || !isOpen(el)) {
      return;
    }

    var top = el.getBoundingClientRect().top;
    var available = viewportHeight() - top;
    if (!(available > 0)) return;

    el.style.setProperty('max-height', available + 'px', 'important');
    el.style.setProperty('height', 'auto', 'important');

    if (content) {
      var recap = el.querySelector('.mini-cart__recap');
      var recapHeight = recap ? recap.getBoundingClientRect().height : 0;
      var forContent = Math.max(0, available - recapHeight);
      content.style.setProperty('max-height', forContent + 'px', 'important');
      content.style.setProperty('overflow-y', 'auto', 'important');
    }
  }

  // The Shopify Inbox bubble is fixed to bottom-right and sits over the cart total.
  function syncChat() {
    var chat = document.querySelector('shopify-chat');
    if (!chat) return;
    if (mobile.matches && isOpen(drawer())) {
      chat.style.setProperty('display', 'none', 'important');
    } else {
      chat.style.removeProperty('display');
    }
  }

  function sync() {
    fit();
    syncChat();
  }

  function schedule() {
    requestAnimationFrame(sync);
  }

  function watch() {
    var el = drawer();
    if (!el || el.dataset.viewportFitBound) return;
    el.dataset.viewportFitBound = '1';
    new MutationObserver(function () {
      if (!isOpen(el)) {
        clear(el);
        clear(el.querySelector('.mini-cart__content'));
      }
      schedule();
    }).observe(el, { attributes: true, attributeFilter: ['aria-hidden'] });
    schedule();
  }

  window.addEventListener('resize', schedule, { passive: true });
  window.addEventListener('scroll', schedule, { passive: true, capture: true });
  window.addEventListener('orientationchange', schedule, { passive: true });
  if (window.visualViewport) {
    window.visualViewport.addEventListener('resize', schedule);
    window.visualViewport.addEventListener('scroll', schedule);
  }
  document.addEventListener('cart:refresh', schedule, true);
  document.addEventListener('product:added', schedule, true);
  if (mobile.addEventListener) {
    mobile.addEventListener('change', schedule);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watch);
  } else {
    watch();
  }
  new MutationObserver(watch).observe(document.body || document.documentElement, { childList: true, subtree: true });
})();
